import RefereeCardIcon from "./referee-card.png";

const styles = {
  container: {
    height: "80vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
  icon: { width: 100, height: 100 },
  title: {
    fontSize: 15,
    marginTop: 30,
    marginBottom: 30,
    fontWeight: "bold",
  },
};

function ErrorFallback({ title }) {
  return (
    <div style={styles.container}>
      <img alt="" src={RefereeCardIcon} style={styles.icon} />

      <span style={styles.title}>
        {title || "Nous ne trouvons pas ce que vous cherchez."}
      </span>

      <p>Contacter le support</p>
    </div>
  );
}

export default ErrorFallback;
